import router from '@/router'
import store from '@/store'
import { getTokenInfo, getMenu,removeOperateTime,removeLogoutFlag } from '@/utils/auth'
import getPageTitle from '@/utils/getPageTitle'
import { getExpiresTime } from '@/api/expires'
import aes from "@/utils/aes"
import { postRefreshToken } from 'api/http.js'
import { sysAppId,isLocal } from "@/settings.js"
import {GetConfigList} from "@/api/api.js";
import { MessageBox } from 'element-ui'
import sm2 from '@/utils/sm2'

//白名单
const whiteList = ['/login','/register','/error']
const noRedirectlist = ['/home', '/404', '/']

const getOtherQuery = (query) => {
  return Object.keys(query).reduce((acc, cur) => {
    if (cur !== "redirect") {
      acc[cur] = query[cur];
    }
    return acc;
  }, {});
}

router.beforeEach(async (to, from, next) => {
  // 设置title
  document.title = getPageTitle(to.meta.title)

    //切换路由刷新缓存
    let temp = next;
    next = function (args) {
      if(!args) {
        let MessageBox1 = MessageBox;
        checkNewVersion(function(){
          MessageBox1.confirm('发现有新版本,请立即升级', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            closeOnClickModal: false,
            type: 'warning'
          }).then(() => {
            window.location.reload(true)
          })
        })
      }
      temp(args);
    }

  // 判断用户是否登录
  const hasToken = getTokenInfo()
  if (isLocal) {
    next()
    return
  }

    //从缓存获取系统配置
    if(localStorage.getItem('sysConfig') && JSON.parse(localStorage.getItem('sysConfig'))){
        window.g = Object.assign(window.g,JSON.parse(localStorage.getItem('sysConfig')))
    }else{//获取最新系统配置
        await getSysConfig()
    }

  // console.log(to.path)
  // 中台跳转
  if (to.path === '/consultationLogin' || to.path === '/logging') {
    // console.log(to.query)
    const _aestoken = to.query.token
    const redirect = to.query.redirecturl || to.query.redirect || '/'

    removeLogoutFlag()
    removeOperateTime()

    if (redirect) {
      localStorage.setItem('resetRedirect', redirect)
    }
    if (_aestoken) {
      try {
        const _tokenObj = JSON.parse(aes.AESDecrypt(decodeURIComponent(_aestoken)))
        await store.dispatch('user/setNewTokenInfoAndGetData', _tokenObj)
      } catch (err) {
        console.error(err)
      }
    }
    next({ path: redirect })
    return
  }else if(to.path === '/hisLogin'){//第三方HIS跳转
    removeLogoutFlag()
    removeOperateTime()
    let obj = await store.dispatch('user/hisLogin',to.query)
    if(obj.url){//跳转到指定系统的地址
        delete to.query.appId
        delete to.query.redirect
        to.query.token = obj.token
        // next({path:obj.url,query:to.query})
        let newUrl = new URL(obj.url)
        for (const key in to.query) {
            if (Object.hasOwnProperty.call(to.query, key)) {
                const el = to.query[key];
                newUrl.searchParams.set(key,el)
            }
        }
        window.location.href = newUrl.href
    }else{//跳转本系统home
        next({ path: '/home/index' })
        return
    }
  }else if(to.path === '/sm2login'){
    removeLogoutFlag()
    removeOperateTime()
    
    await store.dispatch('user/sm2login',to.query)

    const redirect = to.query.redirecturl || to.query.redirect || '/'
    if (redirect) {
        localStorage.setItem('resetRedirect', redirect)
      }

    next({ path: redirect})
    return
  }else if(to.path === '/lzHisLogin'){//联众HIS跳转
    removeLogoutFlag()
    removeOperateTime()

    let CanShuZ = to.query.CanShuZ.replace(/ /g, '+')//base64编码的字符串
    /* let canshu = atob(CanShuZ)//base64解密
    const textDecoder = new TextDecoder('utf-8');
    const text = textDecoder.decode(new Uint8Array([...canshu].map(c => c.charCodeAt(0)))); */
    const redirect = to.query.redirecturl || to.query.redirect || '/'
    if (redirect) {
        localStorage.setItem('resetRedirect', redirect)
      }
    let decData = aes.AESDecrypt(CanShuZ,'706eec8382b64b47')//解密后的字符串
    const regex = /UserID=([^&]*)/;
    const match = decData.match(regex);
    const userId = match ? match[1] : null;
    let params = {
        hospitalCode:'47075008433032611A1001',//平阳人民医院
        data:sm2.SM2Encrypt(JSON.stringify({UserCode:userId}))
    }
    await store.dispatch('user/lzHisLogin',params)

    next({ path: redirect })
    return
  }else if(to.path === '/luLogin'){//山东影像跳转----token不加密
    const _token = to.query.token
    const redirect = to.query.redirecturl || to.query.redirect || '/'

    removeLogoutFlag()
    removeOperateTime()

    if (redirect) {
      localStorage.setItem('resetRedirect', redirect)
    }
      try {
        let params = {
            accessToken:_token,
            auths:new Date().getTime() / 1000,
            expires:new Date().getTime() / 1000 + 28800,
            refreshToken:'',
            type:"Bearer"
        }
        await store.dispatch('user/setNewTokenInfoAndGetData', params)
      } catch (err) {
        console.error(err)
      }
    next({ path: redirect })
    return
  }

  if(window.g.everyLogin){
      if(to.path === '/login'){
        await store.dispatch('user/logout');
        next()
        return;
      }
  }
  const query = to.query;
  let redirect = ''
  let otherQuery = null;
  if (query) {
    redirect = to.path;
    otherQuery = getOtherQuery(query);
  }
  if (hasToken) {
    console.log('有token')

    store.dispatch('app/setPathname', to.name)
    if (to.path === '/login') {
      // 已登录 跳转到首页 //原来是'/'出现循环 现在'/home/index'
      console.log('有token跳转到首页')
      next({ path: '/home/index' })
    } else if (getExpiresTime() > 60) { // 令牌超时判断 10秒
        console.log('令牌未超时')
      if (to.name == '一体化视图') {
        store.dispatch('patient/setInfo', {})
      }

      // 用户信息
      const userName = store.getters.name
      if (userName) {
        if (!getMenu()) {
          // 获取用户菜单
          await store.dispatch('user/getMenu');
        }
        next()
      } else {
        try {
          // 获取用户信息
          await store.dispatch('user/getInfo');
          // 获取用户菜单
          await store.dispatch('user/getMenu');
          next({ ...to, replace: true })
        } catch (error) {
          await store.dispatch('user/logout');
          next({
            path: '/login',
            query: { ...otherQuery, 'redirect': to.path }
          })
        }
      }
    } else {
        console.log('令牌超时')
      const refreshRes = await postRefreshToken()
      if (refreshRes) {
        console.log('令牌已刷新')
        if (!store.getters.name) {
          await store.dispatch('user/getInfo')
        }
        next()
      }else{
        console.log('彻底超时，重新登出')
        await store.dispatch('user/logout');
        next({
          path: '/login',
          query: { ...otherQuery, 'redirect': to.path }
        })
      }
    }
  } else {
    console.log('没有登录，登出系统')
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
        await store.dispatch('user/logout');
      if (noRedirectlist.indexOf(to.path) !== -1) {
        next(`/login`)
      } else {
        next({
          path: '/login',
          query: { ...otherQuery, 'redirect': to.path }
        })
      }
    }
  }
})

function getSysConfig() {
    return new Promise(async(resolve, reject) => {
        await forceReloadJS(process.env.NODE_ENV === 'production' ? '/config.js':'/static/config.js');
        let params = {
            SysAppId:sysAppId,
            Data:'04'+sm2.SM2Encrypt('admin')
        }
        GetConfigList(params).then(res => {
            if (res && res.code === 10000) {
                let config = res.content.list
                if (config) {
                    config.forEach(item => {
                        if(item.isEnabled && item.valueType !== 2 && item.configValue !== ''){//字符型
                            window.g[item.configName] = JSON.parse(item.configValue)
                        }else if(item.isEnabled){
                            window.g[item.configName] = item.configValue
                        }
                    })
                    localStorage.setItem('sysConfig', JSON.stringify(window.g))
                }
            }
            resolve()
        }).catch(() => {
            reject()
        })
    })
  }

function forceReloadJS(url) {
    return new Promise((resolve, reject) => {

        const script = document.createElement('script');
        const timestamp = new Date().getTime();
        script.src = `${url}?t=${timestamp}`; // 时间戳防止缓存
        script.async = true;

        script.onload = ()=>{
             // 清理script标签
          document.head.removeChild(script);
          resolve()
        }

        // 4. 设置加载失败回调
        script.onerror = () => {
          reject(new Error('无法加载配置文件'));
          document.head.removeChild(script);
        };
        
        // 5. 添加到DOM开始加载
        document.head.appendChild(script);
    })
}


// WEBPACK FOOTER //
// ./src/router/permission.js